import { ref } from 'vue';
import type { Ref } from 'vue';
import { compareTimeStrings } from './time-utils';
import type { TimeRange } from './types';

export const useTimeRangeValidation = (): {
  hasErrors: Ref<boolean>;
  errorMessage: Ref<string>;
  validateTimeRanges: (timeRanges: TimeRange[]) => boolean;
} => {
  const hasErrors = ref(false);
  const errorMessage = ref('');

  const validateTimeRanges = (timeRanges: TimeRange[]): boolean => {
    for (const range of timeRanges) {
      if (compareTimeStrings(range[0], range[1], true) >= 0) {
        hasErrors.value = true;
        errorMessage.value = 'End time must be after start time';
        return false;
      }
    }
    const sortedRanges = [...timeRanges].sort((a, b) =>
      compareTimeStrings(a[0], b[0]),
    );
    for (let i = 0; i < sortedRanges.length - 1; i++) {
      if (compareTimeStrings(sortedRanges[i][1], sortedRanges[i + 1][0]) > 0) {
        hasErrors.value = true;
        errorMessage.value = 'Time ranges cannot overlap';
        return false;
      }
    }
    hasErrors.value = false;
    errorMessage.value = '';
    return true;
  };

  return {
    hasErrors,
    errorMessage,
    validateTimeRanges,
  };
};
